/**
 * @generated SignedSource<<d4ee41dc43687bc291025742547950d5>>
 * @relayHash f11d847a636512721f3f51326205860e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f11d847a636512721f3f51326205860e

import { ConcreteRequest } from 'relay-runtime';
export type countrySearchQuery$variables = {
  language: string;
};
export type countrySearchQuery$data = {
  readonly displayableCountries: ReadonlyArray<{
    readonly countryLookup: {
      readonly countryIsoCode2: string;
    };
    readonly countryName: string;
    readonly id: string;
    readonly language: string;
  }>;
};
export type countrySearchQuery = {
  response: countrySearchQuery$data;
  variables: countrySearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "countrySearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryLookup",
            "kind": "LinkedField",
            "name": "countryLookup",
            "plural": false,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "countrySearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryLookup",
            "kind": "LinkedField",
            "name": "countryLookup",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f11d847a636512721f3f51326205860e",
    "metadata": {},
    "name": "countrySearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bcb8204a35e8aa2f1860ee0734b6ceef";

export default node;
